"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./utils/dateUtils"), exports);
__exportStar(require("./utils/devEnvironment"), exports);
__exportStar(require("./utils/feetInches"), exports);
__exportStar(require("./utils/handicapCalcs"), exports);
__exportStar(require("./utils/eventScoreBuilder"), exports);
__exportStar(require("./utils/registrationActiveFilters"), exports);
__exportStar(require("./utils/resolvedStartHole"), exports);
__exportStar(require("./utils/resolveRoundScoreArrayIndexForRound"), exports);
__exportStar(require("./utils/countCompletedHoles"), exports);
__exportStar(require("./utils/paceOfPlayMetrics"), exports);
__exportStar(require("./utils/shotgunSlotUtils"), exports);
